(function () {
    'use strict';

    angular
        .module('elogbooks')
        .controller('LoginStep1Controller', LoginStep1Controller);

    LoginStep1Controller.$inject = [
        '$state',
        '$rootScope',
        '$scope',
        'apiClient',
        'rootResource',
        '$window',
        'stonlyService',
        'Auth0Service',
        'loginService',
        '$stateParams',
        'ssoConfig',
        '$timeout'
    ];

    function LoginStep1Controller(
        $state,
        $rootScope,
        $scope,
        apiClient,
        rootResource,
        $window,
        stonlyService,
        Auth0Service,
        loginService,
        $stateParams,
        ssoConfig,
        $timeout
    ) {
        $rootScope.skipDirtyCheck = true;

        var vm = this;
        vm.forgotUsername = false;

        vm.loginWithSso = loginWithSso;
        vm.forgottenUsername = forgottenUsername;
        vm.cancelForgotUsername = cancelForgotUsername;
        vm.getSessionMatch= getSessionMatch;
        vm.loginStep1 = loginStep1;
        vm.auth0logout = auth0logout;
        vm.setRememberUsername = loginService.setRememberUsernameEnabled;

        // Use shared initialization
        loginService.initVm(vm, rootResource, $stateParams);

        // shared method binding
        vm.recaptchaSetResponse = (response) => {
            loginService.recaptchaSetResponse(vm, response);
        };
        vm.recaptchaSetWidgetId = (widgetId) => {
            loginService.recaptchaSetWidgetId(vm, widgetId);
        };
        vm.recaptchaSetExpiration = () => {
            loginService.recaptchaSetExpiration(vm);
        };
        vm.checkEmail = loginService.checkEmail;
        vm.toggleLink = (type) => {
            loginService.toggleLink(vm, type);
        };
        vm.returnToLogin = (form) => {
            loginService.returnToLogin(vm, form);
        };

        if ($window.localStorage.getItem('recaptchaRequired')) {
            vm.recaptchaCheck = true;
        }

        var alreadySignedIn = loginService.redirectIfLoggedIn();

        // Only ask Auth0 who's signed in when it was configured; the client exists
        // either way (see app.config.js) but querying an unconfigured one is pointless
        // and rejects. Users on the password path never notice either way.
        if (ssoConfig.isUsable()) {
            Auth0Service.getCurrentUserEmail().then(function(auth0Email) {
                if (auth0Email) {
                    vm.auth0User = auth0Email;
                }
            });
        }

        // Central Landing Page handoff: take the username step for the user instead of
        // asking them to retype the account the landing page has just shown them.
        //
        // A handoff is the first entry to this screen in a page load, and only that -
        // back() and denyPasswordLogin() both route back here with a username, and
        // re-deriving from the params would bounce the user to step 2 for good. The flag
        // is set on entry, not on the handoff, so a login typed by hand also arms it.
        // loginFailMsg covers the same-load return from denyPasswordLogin().
        //
        // $stateParams rather than vm.credentials.username, which initVm also fills from
        // a remembered username.
        var firstEntry = !$rootScope.loginStep1Entered;
        $rootScope.loginStep1Entered = true;

        var handoff = firstEntry
            && !alreadySignedIn
            && !!($stateParams.username || '').trim()
            && !$rootScope.loginFailMsg;

        // Cleared wherever the screen goes back to the user, so it never hides the form.
        // An already-signed-in landing is being redirected too, so it shows the same
        // message instead of flashing the form while the session bootstraps. firstEntry
        // only: a later entry means something bounced us back, and the form must return.
        vm.handoffInProgress = handoff || (firstEntry && alreadySignedIn);

        if (vm.handoffInProgress) {
            vm.loading = true;
        }

        if (handoff) {
            loginStep1(true);
        }

        // Back from the Auth0 page: the browser may restore this page from its back/forward
        // cache exactly as it was left, spinner and disabled form included, without running
        // the controller again. No callback is coming, so hand the form back to the user
        // and drop the in-flight markers (the next state change would otherwise be diverted
        // into auth0-processing).
        function onPageShow(event) {
            if (!event.persisted) {
                return;
            }

            $window.localStorage.removeItem('auth0LoginInProgress');
            $window.localStorage.removeItem('ssoDestination');

            $timeout(function () {
                vm.loading = false;
                vm.handoffInProgress = false;
            });
        }

        $window.addEventListener('pageshow', onPageShow);
        $scope.$on('$destroy', function () {
            $window.removeEventListener('pageshow', onPageShow);
        });

        // Nothing else hands the form back if the redirect fails: $stateChangeError does
        // not re-route while we are already on login.step1. Broadcast from $rootScope, so
        // it reaches this scope, which also deregisters it.
        $scope.$on('$stateChangeError', function () {
            vm.handoffInProgress = false;
            vm.loading = false;
        });

        async function getSessionMatch() {
            const auth0Email = await Auth0Service.getCurrentUserEmail();
            if (!auth0Email) {
                return false;
            }

            try {
                const response = await apiClient.get('/sso/session-match', { username: vm.credentials.username, email: auth0Email });
                if (response.sessionMatch == true) {
                    return true;
                }

            } catch (error) {
                console.error('Error getting session match:', error);
                return false;
            }

            return false
        }


        // isHandoff: started for the user, not by them. ng-submit passes no argument.
        function loginStep1(isHandoff) {
            vm.loading = true;
            vm.loginFailMsg = null;
            $rootScope.loginFailMsg = null;
            if (!vm.credentials.username) {
                vm.loading = false;
                vm.handoffInProgress = false;
                return;
            }

            loginService.fetchNextHint(vm.credentials.username).then(function (hint) {
                if (hint === 'sso') {
                    $window.localStorage.setItem('ssoUsername', vm.credentials.username);
                    loginService.rememberUsername(vm.credentials.username);
                    loginWithSso();
                    return;
                }

                if (hint === 'password') {
                    // Say why a password screen appeared, without saying which of
                    // unknown, disabled or not-on-SSO it was.
                    if (isHandoff) {
                        $rootScope.loginFailMsg = 'CLP_HANDOFF_PASSWORD_REQUIRED';
                    }

                    $state.go('login.step2', {
                        username: vm.credentials.username,
                        destination: $stateParams.destination
                    });
                    return;
                }

                // Indeterminate. Refuse rather than fall through to the password
                // form: that would hand an SSO user a password login whenever
                // /sso/next-hint is unavailable. Recoverable - the user can retry.
                vm.loading = false;
                vm.handoffInProgress = false;
                vm.loginFailMsg = 'SSO_NEXT_HINT_UNAVAILABLE';
            });
        }

        async function loginWithSso() {
            if (!ssoConfig.isUsable()) {
                console.error(
                    'Refusing SSO login; Auth0 configuration is incomplete, missing: ' +
                    ssoConfig.getMissingParams().join(', ')
                );
                vm.loading = false;
                vm.handoffInProgress = false;
                vm.loginFailMsg = $rootScope.loginFailMsg = 'SSO_CONFIGURATION_UNAVAILABLE';
                return;
            }

            vm.loginFailMsg = null;
            $rootScope.loginFailMsg = null;
            stonlyService.init() // TODO maybe this should be moved to success state

            try {
                const matched = await vm.getSessionMatch();

                var loginParams = {
                    connection: "CAFM-SPA" // TODO this will have to be checked against the user and returned. AD vs DB Can be phase 2
                };

                if (!matched) {
                    loginParams.prompt = 'select_account'
                }

                // Preserve any bookmarked destination across the Auth0 redirect. The
                // SSO round-trip state lives in localStorage (not state params), so
                // stash it there for handleLoginResult to honour on the way back.
                if ($stateParams.destination) {
                    $window.localStorage.setItem('ssoDestination', $stateParams.destination);
                } else {
                    $window.localStorage.removeItem('ssoDestination');
                }

                // Set last, after every await: the $stateChangeStart hook in
                // app.config.js reads auth0LoginInProgress as "a callback is
                // arriving". Set before an await, any state change in the gap makes
                // the hook consume the flag on a URL with no code/state, so the real
                // callback is ignored when Auth0 redirects back.
                $window.localStorage.setItem('auth0LoginInProgress', 'true');

                await Auth0Service.loginWithRedirect(loginParams);
            } catch (error) {
                // The hand-off failed, so no callback is coming. Clear the flag or the
                // hook above diverts the next state change into auth0-processing, finds
                // no callback params, and bounces the user back here mid-journey.
                console.error('Failed to hand off to Auth0 (never left the app):', error);
                $window.localStorage.removeItem('auth0LoginInProgress');
                $window.localStorage.removeItem('ssoDestination');

                // Native async continuation - outside the digest, so bounce back in.
                $timeout(function () {
                    vm.loading = false;
                    vm.handoffInProgress = false;
                    vm.loginFailMsg = $rootScope.loginFailMsg = 'SSO_AUTH_REDIRECT_ERROR';
                });
            }
        }

        function forgottenUsername() {
            vm.loading = true;
            vm.usernameError = false;

            apiClient.create(rootResource.getLink('forgot-username-request'), {
                email: vm.email
            }).then(function (response) {
                if (response) {
                    vm.loading = vm.usernameError = false;
                    vm.usernameRequestSubmitted = true;
                } else {
                    vm.loading = false;
                    vm.usernameError = true;
                }
            });
        }

        function cancelForgotUsername(form) {
            vm.forgotUsername = !vm.forgotUsername;
            vm.email = vm.loginFailMsg = $rootScope.loginFailMsg = vm.usernameError = null;
            form.$setPristine();
        }

        function auth0logout() {
            Auth0Service.logout();
        }
    }
})();
